<template>
  <div class="spare-illust">
    <!-- <h3>{{ unit.name }}:</h3> -->
    <div class="row unit-navi">
      <v-select
        style="margin-bottom: 20px;"
        :options="units"
        v-model="selectedUnit"
        :clearable="false"
        @input="selectUnitFromNav()"
        label="name"
      >
        <template v-slot:option="unit">
          <span :class="unit.category"></span>
          <div class="select-icon">
            <img :src="'https://teilecdn.com/assets/icons/' + unit.category + '.svg'" />
            {{ unit.name }}
          </div>
        </template>
      </v-select>&nbsp;
      <div class="btn-group" style="float: right">
        <button
          @click="goToPrevUnit()"
          type="button"
          class="btn btn-sm"
          :class="`btn-action-${brand}`"
        >
          <img class="back-icon" src="https://teilecdn.com/assets/icons/left-arrow.svg" />
          {{ $t("message.previous") }}
        </button>
        <button
          @click="goToNextUnit()"
          type="button"
          class="btn btn-sm"
          :class="`btn-action-${brand}`"
        >
          {{ $t("message.next") }}
          <img
            class="back-icon"
            src="https://teilecdn.com/assets/icons/right-arrow.svg"
          />
        </button>
      </div>
    </div>

    <div class="illust-diagram" :class="`${brand}-border`">
      <img
        class="illust-img"
        :style="{width: isKawa ? '731px' : '', height: isKawa ? '33%' : ''}"
        :src="unit.illustUrl"
      />
      <v-popover
        offset="0"
        v-for="point in points"
        :key="point.id"
        :style="{ top: isTop ? point.y + 'px' : '', bottom: !isTop ? point.y + 'px' : '',  left: point.x + 'px' }"
        :class="`${brand}-point`"
        trigger="hover focus"
      >
        <div
          :style="{ width: point.width + 'px', height: point.height+ 'px'}"
          @mouseover="mouseOverPoint(point)"
          class="point"
        ></div>
        <PriceBox slot="popover" />
      </v-popover>
    </div>
  </div>
</template>

<script>
import PriceBox from '@/components/spare/partials/PriceBox.vue';
import { mapActions } from 'vuex';

export default {
  name: 'SpareIllust',
  components: {
    PriceBox,
  },
  computed: {
    isTop: function () {
      if (
        this.$store.state.brand == 'yamaha' ||
        this.$store.state.brand == 'kawasaki'
      )
      return true;
      else return false;
    },
    isKawa: function () {
      if (this.$store.state.brand == 'kawasaki') return true;
      else return false;
    },
    brand: {
      get() {
        return this.$store.state.brand;
      },
    },
    unit: {
      get() {
        return this.$store.state.selectedUnit;
      },
    },
    units: {
      get() {
        return this.$store.state.availableUnits;
      },
    },
    points: {
      get() {
        return this.$store.state.points;
      },
    },
    selectedUnit: {
      set(value) {
        this.$store.commit('setUnit', value);
      },
      get() {
        return this.$store.state.selectedUnit;
      },
    },
  },
  methods: {
    ...mapActions([
      'mouseOverPoint',
      'selectUnitFromNav',
      'goToPrevUnit',
      'goToNextUnit',
    ]),
  },
};
</script>